export const ReasonEN = {
    "decisionReason": {
        "title": "Create reason",
        "label": {
            "reason": "Reason",
            "status": "Status"
        },
        "placeholder": {
            "reason": "Reason"
        },
        "option": {
            "active": "Active",
            "inActive": "InActive"
        },

    }
}